import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import './App.css'
import sizeS from './sizeS.png'
import sizeM from './sizeM.png'
import sizeL from './sizeL.jpeg'
import sizeXL from './sizeXL.png'
import iso14001 from './iso.png'
import oekoTex from './oeko-tex.png'
import fsc from './fsc.png'
import ce from './ce.svg'
// import miki3 from './DSC_9628.jpg'
import Intro from './Intro'
import AboutUs from './AboutUs'
import Form from './Form'
import Header from './Header'
import Footer from './Footer'

function App () {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash)
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' })
        }, 0)
      }
    }
  }, [location])

  return (
    <main className='app'>
      <Header />
      <div>
        <Intro />

        <AboutUs />

        <section className='products' id='produkty'>
          <h1 className='tittle'>Produkty</h1>
          <h2 className='products-tittle'>
            Dlaczego nasze pieluszki są wyjątkowe?
          </h2>
          <ul className='product-list'>
            <li className='product-item'>
              <a
                href='https://allegro.pl/oferta/pieluszki-jednorazowe-dla-dzieci-rozmiar-s-4-8-kg-bambi-17530081677'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={sizeS} alt='pieluszka' />
              </a>
              <div>
                <h3>Niezwykła miękkość i delikatność</h3>
                <p>
                  Wykonane z włókien polipropylenowych - lekkich, oddychających
                  i przyjemnych niczym chmurka zapewniają maksymalny komfort
                  nawet dla najbardziej wrażliwej skóry.
                </p>
              </div>
            </li>
            <li className='product-item'>
              <a
                href='https://allegro.pl/oferta/pieluszki-jednorazowe-dla-dzieci-rozmiar-m-6-11-kg-bambi-17530291470'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={sizeM} alt='pieluszka' />
              </a>
              <div>
                <h3>Suchość gwarantowana</h3>
                <p>
                  Dzięki obecności super absorbującego polimeru, wilgoć jest
                  błyskawicznie wchłaniana i zatrzymywana wewnątrz pieluszki.
                  Efekt ? Skóra dziecka pozostaje sucha i chroniona przez długie
                  godziny- nawet podczas snu.
                </p>
              </div>
            </li>
            <li className='product-item'>
              <a
                href='https://allegro.pl/oferta/pieluszki-jednorazowe-dla-dzieci-rozmiar-l-9-14-kg-bambi-18674329324'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={sizeL} alt='pieluszka' />
              </a>
              <div>
                <h3>Naturalna puszystość</h3>
                <p>
                  Wewnątrz znajduje się pulpa puchowa - naturalny, miękki
                  materiał drzewny, który odpowiada za idealne dopasowanie i
                  subtelne otulenie. To jak przytulenie do pluszowego misia -
                  tylko codziennie i zawsze wtedy, kiedy trzeba!
                </p>
              </div>
            </li>
            <li className='product-item'>
              <a
                href='https://allegro.pl/oferta/pieluszki-jednorazowe-dla-dzieci-rozmiar-xl-12-17-kg-bambi-17530343058'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={sizeXL} alt='pieluszka' />
              </a>
              <div>
                <h3>Dla Ciebie i Twojego maluszka</h3>
                <p>
                  Nasze pieluszki łączą nowoczesne technologie z troską o
                  naturalną wygodę. To produkt, który został zaprojektowany z
                  myślą o Tobie i Twoim dziecku - abyście mogli skupić się na
                  tym, co najważniejsze: wspólnym odkrywaniu świata.
                </p>
              </div>
            </li>
          </ul>
        </section>

        <section className='certs' id='certyfikaty'>
          <h1>Certyfikaty</h1>
          <ul>
            <li>
              <img src={iso14001} alt='ISO 14001' />
            </li>
            <li>
              <img src={oekoTex} alt='oeko tex' />
            </li>
            <li>
              <img src={fsc} alt='FSC' />
            </li>
            <li>
              <img src={ce} alt='CE' />
            </li>
          </ul>
        </section>

        <section className='form-section' id='probka'>
          <h1>
            Poznaj jakość, która mówi sama za siebie. Wypełnij formularz, a my
            wyślemy Ci darmową pieluszkę próbną – bo zasługujesz na pewność, że
            wybierasz to, co najlepsze dla Twojego dziecka.
          </h1>
          <Form />
        </section>
        <section id='kontakt'>
          <Footer />
        </section>
      </div>
    </main>
  )
}

export default App
